import { render, staticRenderFns } from "./modelConfigure.vue?vue&type=template&id=32ef3bac&scoped=true"
import script from "./modelConfigure.vue?vue&type=script&lang=js"
export * from "./modelConfigure.vue?vue&type=script&lang=js"
import style0 from "./modelConfigure.vue?vue&type=style&index=0&id=32ef3bac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ef3bac",
  null
  
)

export default component.exports